import React from 'react'
import PropTypes from 'prop-types'
import { scrollToElement } from 'LiveBoard/components/mobile/helper'

import './style.css.scss'

const GoToContent = ({ textColor }) => {
  return (
    <div
      className='go-to-content'
      style={{color: textColor}}
      onClick={() => scrollToElement({ elemClass: 'board-content-container' })}>
      <span className='icon-container' style={{borderColor: textColor}}>
        <span className='icon-arrow-down' style={{color: textColor}} />
      </span>
    </div>
  )
}

GoToContent.propTypes = {
  textColor: PropTypes.string.isRequired
}

export default GoToContent
